const NOT_TAWK_CHAT_TYPES = new Set(["webcam", "mobile", "mobile_webcam"]);

export function getOrganizationChatType(organization) {
  const raw = organization?.chat_type ?? organization?.chatType ?? "";
  return String(raw).trim().toLowerCase();
}

export function buildNotTawkOrganizationIds(organizations) {
  const ids = new Set();
  if (!Array.isArray(organizations)) return ids;
  for (const organization of organizations) {
    const id = organization?.id;
    if (!id) continue;
    if (NOT_TAWK_CHAT_TYPES.has(getOrganizationChatType(organization))) {
      ids.add(id);
    }
  }
  return ids;
}

export function isNotTawkSession(session, notTawkOrganizationIds) {
  const organizationId = session?.organizationId;
  if (!organizationId || !notTawkOrganizationIds?.size) return false;
  return notTawkOrganizationIds.has(organizationId);
}

export function sessionTawkLabel(session, notTawkOrganizationIds) {
  return isNotTawkSession(session, notTawkOrganizationIds)
    ? "not-tawk"
    : "tawk";
}
